export const MIN_DESCRIPTION_CHARS = 20;
export const FIELD_VERTICAL_SPACING = 30;
